define('mailsListMailLabelView',[
  'module',
  'windows',
  'marionette',
  'underscore',
  'template!mailsListMailLabelView'
], function (
  Module,
  Windows,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,    
    className: 'label-view',

    onRender: function() {
      var lbl = this.model.get('label');
      if(lbl) {
        this.$el.css('background-color', lbl.backgroundColor);
        this.$el.css('color', lbl.textColor);
      }
    },

    serializeData: function () {
      var lbl = this.model.get('label');
      if(lbl) {
        return {
          name: lbl.name
        };
      } else {
        return {
            name: ''
        };
      }
    }
  });
});
  
